@if (vm) {
    <section class="antepost-fixture__market">
        @if (showFixtureMarketTitle) {
            <header msTextAutoScroll [marqueeAutoScroll]="true">
                <div>
                    <ms-fixture-market-title [fixture]="vm.fixture" />
                </div>
            </header>
        } @else {
            <div class="sort-by">
                <ms-dropdown
                    [activeOption]="activeOption"
                    [isIconTemplate]="true"
                    [options]="dropDownItems"
                    (optionChange)="orderBy($event.payload)"
                    (dropdownState)="trackDropdownToggle()">
                    <vn-icon icon class="sort-icon" name="sports-greyhounds-sorting" size="16" />
                </ms-dropdown>
            </div>
        }
        <div class="antepost-fixture__pick-list">
            @switch (vm.isOptionBet) {
                @case (true) {
                    <ms-antepost-option-market [fixture]="vm.fixture" [sortBy]="sortBy" />
                }
                @case (false) {
                    <ms-antepost-participants [fixture]="vm.fixture" />
                }
            }
        </div>
    </section>
}
